export default __webpack_public_path__ + "static/media/mobile_index.03aa7267.jpg";